import { Tabs, withStyles } from '@material-ui/core'

const AsterTabs = withStyles({
  root: {},

  indicator: {
    display: 'none',
    backgroundColor: 'none'
  },
  flexContainer: {
    overflowX: 'auto'
  }
})(Tabs)
export default AsterTabs
